import { render, staticRenderFns } from "./sidebarList.vue?vue&type=template&id=5ae8af22&"
import script from "./sidebarList.vue?vue&type=script&lang=js&"
export * from "./sidebarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports